module.exports = __webpack_public_path__ + "img/ef805f7c63c78646b95ddc30e6e59343.svg";